import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from 'store/hooks';
import { closeModal } from 'features/modal/modalSlice';
import { contentPushed } from 'features/layout/features/content/actions';
import ConfirmationDialog from 'components/ConfirmationDialog';
import { useLockContentControl } from 'features/layout/grid-panel/controls/GridPanelLockControl/useLockContentControl';

const PushLockedContentConfirmation = () => {
  const { t } = useTranslation('modals');

  const dispatch = useAppDispatch();

  const { controlEnabled } = useLockContentControl();

  const shouldClose = !controlEnabled;

  useEffect(() => {
    if (shouldClose) {
      dispatch(closeModal('pushLockedContentConfirm'));
    }
  }, [shouldClose, dispatch]);

  const handleCancel = () => {
    dispatch(closeModal('pushLockedContentConfirm'));
  };

  const handleConfirm = () => {
    dispatch(contentPushed());
    dispatch(closeModal('pushLockedContentConfirm'));
  };

  return (
    <ConfirmationDialog
      open={!shouldClose}
      title={t('push_locked_content.title')}
      description={t('push_locked_content.description')}
      cancelText={t('push_locked_content.btn_cancel_label')}
      okText={t('push_locked_content.btn_ok_label')}
      onCancel={handleCancel}
      onOk={handleConfirm}
      hideCloseButton
      preventClose
    />
  );
};

export default PushLockedContentConfirmation;
